// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"a512e7de","249":"253210f0","278":"437250a0","324":"54fe7e5a","431":"743bd2d6","627":"2c981bde","693":"2a8ca24d","922":"f52a7c4b","940":"6f2b4674"}[chunkId] + ".chunk.js";
};